///////////////////////////////////UPDATED RUNNING CODE:: ////////////////////////////////////////////////////

import React, { useState } from 'react';
import classes from './RateFood.module.scss';
import toast from 'react-hot-toast';
import ReactStars from 'react-rating-stars-component';
import { canteenFeedback } from '../../../API/API';

const RateFood = ({ token_no, onClose }) => {
    const [rating, setRating] = useState(0);
    const [remarks, setRemarks] = useState('');
    const userID = localStorage.getItem('userID');
    const empID = localStorage.getItem('empID');
    const data = JSON.parse(localStorage.getItem('data'));

    const handleRatingChange = (newRating) => {
        console.log('New rating:', newRating);
        setRating(newRating);
    };
    
    const handleFeedbackChange = (event) => {
        console.log('New feedback:', event.target.value);
        setRemarks(event.target.value);
    };

    const handleSubmit = async () => {
        console.log('Rating:', rating);
        console.log('Feedback:', remarks);
        console.log('Rate Food data.empid, data.token, token_no:', data.empid, data.token, token_no);
        try {
            const response = await canteenFeedback(userID, data.empid, data.token, token_no, rating, remarks);
            console.log('Response:', response);

            if (response) {
                toast.success('Feedback submitted successfully!');
            } else {
                toast.error('Failed to submit feedback. Please try again.');
            }
            onClose();
        } catch (error) {
            toast.error('Failed to submit feedback.');
            console.error('Error submitting feedback:', error);
        }
    };

    return (
        <div className={classes.RateFood}>
            <h2>Rate Your Food</h2>
            <div className={classes.Rating}>
                <label>Rating: </label>
                <ReactStars
                    count={5}
                    onChange={handleRatingChange}
                    size={50}
                    activeColor="#ffd700"
                />
            </div>
            <div className={classes.Feedback}>
                <label>Feedback: </label>
                <textarea value={remarks} onChange={handleFeedbackChange} />
            </div>
            <div className={classes.Actions}>
                <button onClick={handleSubmit}>Submit</button>
                <button onClick={onClose}>Cancel</button>
            </div>
        </div>
    );
};

export default RateFood;







// import React, { useState } from 'react';
// import classes from './RateFood.module.scss';
// import toast from 'react-hot-toast';
// import ReactStars from 'react-rating-stars-component';
// import { canteenFeedback } from '../../../API/API';

// const RateFood = ({ token_no, onClose }) => {
//     const [rating, setRating] = useState(0);
//     const [remarks, setRemarks] = useState('');
//     const userID = localStorage.getItem('userID');
//     const empID = localStorage.getItem('empID');
//     const data = JSON.parse(localStorage.getItem('data'));

//     const handleRatingChange = (newRating) => {
//         console.log('New rating:', newRating); 
//         setRating(newRating);
//     };

//     const handleFeedbackChange = (event) => {
//         console.log('New feedback:', event.target.value); 
//         setRemarks(event.target.value);
//     };

//     const handleSubmit = async () => {
//         console.log('Rating:', rating); 
//         console.log('Feedback:', remarks); 
//         console.log('Rate Food  data.empid, data.token, @@@@@@@@@@@@@@@@@ ',  data.empid, data.token, token_no)
//         try {
//            canteenFeedback(userID, data.empid, data.token,token_no, rating, remarks)
//             .then(response =>{
//                 console.log("response @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@", response);
//                  if(response.status === "S")
//                     toast.success('Feedback submitted successfully!');
                 
//             })
           
//             // toast.success('Feedback submitted successfully!');
           
//             onClose();
//         } catch (error) {
//             toast.error('Failed to submit feedback.');
//             console.error('Error submitting feedback:', error); 
//         }
//         // toast.success('Feedback submitted successfully!');
//         onClose();
//     };

//     return (
//         <div className={classes.RateFood}>
//             <h2>Rate Your Food</h2>
//             <div className={classes.Rating}>
//                 <label>Rating: </label>
//                 <ReactStars
//                     count={5}
//                     onChange={handleRatingChange}
//                     size={50}
//                     activeColor="#ffd700"
//                 />
//             </div>
//             <div className={classes.Feedback}>
//                 <label>Feedback: </label>
//                 <textarea value={remarks} onChange={handleFeedbackChange} />
//             </div>
//             <div className={classes.Actions}>
//                 <button onClick={handleSubmit}>Submit</button>
//                 <button onClick={onClose}>Cancel</button>
//             </div>
//         </div>
//     );
// };

// export default RateFood;



/////////////////////////////////////////////////////// DEPLOYED CODE ////////////////////////////////////////////////////////////////////////

// import React, { useState, useEffect } from 'react';
// import classes from './RateFood.module.scss';
// import toast from 'react-hot-toast';
// import ReactStars from 'react-rating-stars-component';
// import { canteenFeedback } from '../../../API/API';

// const RateFood = ({ token_no, onClose }) => {
//     const [rating, setRating] = useState(0);
//     const [remarks, setRemarks] = useState('');
//     const [isSubmitted, setIsSubmitted] = useState(false);
//     const [isTokenDisabled, setIsTokenDisabled] = useState(false);
//     const userID = localStorage.getItem('userID');
//     const empID = localStorage.getItem('empID');
//     const data = JSON.parse(localStorage.getItem('data'));

//     useEffect(() => {
//         // Check if feedback was already submitted for this token
//         const submittedTokens = JSON.parse(localStorage.getItem('submittedTokens')) || [];
//         if (submittedTokens.includes(token_no)) {
//             setIsSubmitted(true);
//         } else {
//             setIsSubmitted(false);
//         }

//         // Disable the token if it's equal to 999
//         if (token_no === 999) {
//             setIsTokenDisabled(true);
//         } else {
//             setIsTokenDisabled(false);
//         }
//     }, [token_no]);

//     const handleRatingChange = (newRating) => {
//         setRating(newRating);
//     };

//     const handleFeedbackChange = (event) => {
//         setRemarks(event.target.value);
//     };

//     const handleSubmit = async () => {
//         try {
//             const response = await canteenFeedback(userID, data.empid, data.token, token_no, rating, remarks);
          
//             if (response) {
//                 toast.success('Feedback submitted successfully!');
//                 setIsSubmitted(true);

//                 // Store the submitted token in local storage to prevent re-submission
//                 const submittedTokens = JSON.parse(localStorage.getItem('submittedTokens')) || [];
//                 localStorage.setItem('submittedTokens', JSON.stringify([...submittedTokens, token_no]));
//             } else {
//                 toast.error('Failed to submit feedback. Please try again.');
//             }
//             onClose();
//         } catch (error) {
//             toast.error('Failed to submit feedback.');
//             console.error('Error submitting feedback:', error);
//         }
//     };

//     return (
//         <div className={classes.RateFood}>
//             <h2>Rate Your Food</h2>
//             <div className={classes.TokenNumber}>
//                 <label>Token Number: </label>
//                 <span className={isSubmitted || isTokenDisabled ? classes.DisabledToken : ''}>{token_no}</span>
//             </div>
//             {!isSubmitted && !isTokenDisabled && (
//                 <>
//                     <div className={classes.Rating}>
//                         <label>Rating: </label>
//                         <ReactStars
//                             count={5}
//                             onChange={handleRatingChange}
//                             size={50}
//                             activeColor="#ffd700"
//                             value={rating}
//                             isHalf={false}
//                         />
//                     </div>
//                     <div className={classes.Feedback}>
//                         <label>Feedback: </label>
//                         <textarea 
//                             value={remarks} 
//                             onChange={handleFeedbackChange} 
//                             required
//                         />
//                     </div>
//                 </>
//             )}
//             <div className={classes.Actions}>
//                 <button 
//                     onClick={handleSubmit} 
//                     disabled={isSubmitted || isTokenDisabled} // Disable submit button if feedback is submitted or token is disabled
//                 >
//                     Submit
//                 </button>
//                 <button onClick={onClose}>Cancel</button>
//             </div>
//         </div>
//     );
// };

// export default RateFood;



  //////////////Running Code::::::::
  
// import React, { useState, useEffect } from 'react';
// import classes from './RateFood.module.scss';
// import toast from 'react-hot-toast';
// import ReactStars from 'react-rating-stars-component';
// import { canteenFeedback } from '../../../API/API';

// const RateFood = ({ token_no, onClose, tokenDate }) => {
//     const [rating, setRating] = useState(0);
//     const [remarks, setRemarks] = useState('');
//     const [isTokenValid, setIsTokenValid] = useState(false); // Here we changes the (1135 line number) code in which replace the false as true.
//     //const [isTokenValid, setIsTokenValid] = useState(true);
//     const userID = localStorage.getItem('userID');
//     const empID = localStorage.getItem('empID');
//     const data = JSON.parse(localStorage.getItem('data'));

//     useEffect(() => {
//         // Check if the token date is today's date
//         const today = new Date().toISOString().split('T')[0]; // Get today's date in 'YYYY-MM-DD' format
//         setIsTokenValid(tokenDate === today);
//     }, [tokenDate]);

//     const handleRatingChange = (newRating) => {
//         if (isTokenValid) { // Only allow rating for today's token
//             console.log('New rating:', newRating);
//             setRating(newRating);
//         } else {
//             toast.error('Rating is disabled for previous tokens.');
//         }
//     };

//     const handleFeedbackChange = (event) => {
//         console.log('New feedback:', event.target.value);
//         setRemarks(event.target.value);
//     };

//     const handleSubmit = async () => {
//         if (!isTokenValid) {
//             toast.error('Only today’s tokens are allowed for feedback.');
//             return;
//         }

//         console.log('Rating:', rating);
//         console.log('Feedback:', remarks);
//         console.log('Rate Food data.empid, data.token, @@@@@@@@@@@@@@@@@ ', data.empid, data.token, token_no);

//         try {
//             const response = await canteenFeedback(userID, data.empid, data.token, token_no, rating, remarks);
//             console.log("response @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@", response);
//             if (response.status === "S") {
//                 toast.success('Feedback submitted successfully!');
//             } else {
//                 toast.error('Failed to submit feedback.');
//             }
//         } catch (error) {
//             toast.error('Failed to submit feedback.');
//             console.error('Error submitting feedback:', error);
//         }
//         onClose();
//     };

//     return (
//         <div className={classes.RateFood}>
//             <h2>Rate Your Food</h2>
//             <div className={classes.Rating}>
//                 <label>Rating: </label>
//                 <ReactStars
//                     count={5}
//                     onChange={handleRatingChange}
//                     size={50}
//                     activeColor="#ffd700"
//                     value={rating}
//                     edit={isTokenValid} // Disable rating interaction for previous tokens
//                 />
//             </div>
//             <div className={classes.Feedback}>
//                 <label>Feedback: </label>
//                 <textarea value={remarks} onChange={handleFeedbackChange} />
//             </div>
//             <div className={classes.Actions}>
//                 <button onClick={handleSubmit} disabled={!isTokenValid}>
//                     Submit
//                 </button>
//                 <button onClick={onClose}>Cancel</button>
//             </div>
//             {!isTokenValid && (
//                 <p style={{ color: 'red' }}>
//                     Feedback for previous tokens is disabled. Only today’s tokens can be rated.
//                 </p>
//             )}
//         </div>
//     );
// };

// export default RateFood;









//////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////Testing Code for Running Code::::::::::::::::::::::::::::::::::::::
//////////////////////////////////////////////////////////////////////////////////////////////////////////
// import React, { useState, useEffect } from 'react';
// import classes from './RateFood.module.scss';
// import toast from 'react-hot-toast';
// import ReactStars from 'react-rating-stars-component';
// import { canteenFeedback } from '../../../API/API';

// const RateFood = ({ token_no, onClose, trans_date }) => {
//     const [rating, setRating] = useState(0);
//     const [remarks, setRemarks] = useState('');
//     const [isTokenValid, setIsTokenValid] = useState(false);
//     const userID = localStorage.getItem('userID');
//     const data = JSON.parse(localStorage.getItem('data'));

//     useEffect(() => {
//         if (!trans_date) {
//             console.error('Error: trans_date is undefined or null');
//             setIsTokenValid(false);
//             return;
//         }

//         try {
//             const today = new Date().toISOString().split('T')[0]; // Get today's date in 'YYYY-MM-DD' format
//             const transDateOnly = trans_date.split(' ')[0]; // Extract 'YYYY-MM-DD' part of the trans_date

//             console.log('Today\'s Date:', today);
//             console.log('Transaction Date Only:', transDateOnly);

//             // Compare only the date parts
//             const isValid = transDateOnly === today;
//             setIsTokenValid(isValid);
//             console.log('Is Token Valid:', isValid);
//         } catch (error) {
//             console.error('Error parsing trans_date:', error);
//             setIsTokenValid(false);
//         }
//     }, [trans_date]);

//     const handleRatingChange = (newRating) => {
//         setRating(newRating);
//     };

//     const handleFeedbackChange = (event) => {
//         setRemarks(event.target.value);
//     };

//     const handleSubmit = async () => {
//         if (!isTokenValid) {
//             toast.error('Only today’s tokens are allowed for feedback.');
//             return;
//         }

//         if (rating === 0) {
//             toast.error('Please provide a rating before submitting.');
//             return;
//         }

//         try {
//             const response = await canteenFeedback(userID, data?.empid, data?.token, token_no, rating, remarks);

//             if (response.status === 'S') {
//                 toast.success('Feedback submitted successfully!');
//                 onClose();
//             } else {
//                 toast.error('Failed to submit feedback.');
//             }
//         } catch (error) {
//             toast.error('Failed to submit feedback.');
//             console.error('Error submitting feedback:', error);
//         }
//     };

//     return (
//         <div className={classes.RateFood}>
//             <h2>Rate Your Food</h2>
//             <div className={classes.Rating}>
//                 <label>Rating: </label>
//                 <ReactStars
//                     count={5}
//                     onChange={handleRatingChange}
//                     size={50}
//                     activeColor="#ffd700"
//                     value={rating}
//                     edit={true}
//                 />
//             </div>
//             <div className={classes.Feedback}>
//                 <label>Feedback: </label>
//                 <textarea 
//                     value={remarks} 
//                     onChange={handleFeedbackChange} 
//                     placeholder="Share your thoughts here..."
//                 />
//             </div>
//             <div className={classes.Actions}>
//                 <button 
//                     onClick={handleSubmit} 
//                     disabled={!isTokenValid || rating === 0}
//                 >
//                     Submit
//                 </button>
//                 <button onClick={onClose}>Cancel</button>
//             </div>
//             {!isTokenValid && (
//                 <p style={{ color: 'red', marginTop: '10px' }}>
//                     Feedback for previous tokens is disabled. Only today’s tokens can be rated.
//                 </p>
//             )}
//         </div>
//     );
// };

// export default RateFood;







////////////-------------------------------------------------------------------
//////Understanding Code for testing::::::
////////////////////////////////-----------------------------------------------

// import React, { useState, useEffect } from 'react';
// import classes from './RateFood.module.scss';
// import toast from 'react-hot-toast';
// import ReactStars from 'react-rating-stars-component';
// import { canteenFeedback } from '../../../API/API';

// const RateFood = ({ token_no, onClose, tokenDate }) => {      ////here token date define:::
//     const [rating, setRating] = useState(0);                  ///onClose uses to handle handle closing or hiding the component (like closing a modal or feedback form).
//     const [remarks, setRemarks] = useState('');
//     const [isTokenValid, setIsTokenValid] = useState(false);   ////Initially, the token is assumed to be invalid (false). Later, in the useEffect hook, the value of isTokenValid is updated based on whether the tokenDate matches today's date.
//     const userID = localStorage.getItem('userID');            ////
//     const data = JSON.parse(localStorage.getItem('data'));
//     const today = new Date().toLocaleDateString('en-CA');   //added new    ::For date
//     //const tokenDate = today;    //added new       Here error comes because tokenDate define two times.....
//     console.log(data);
//     //console.log(tokenDate);
//     useEffect(() => {               ////useEffect called automatically when the component is rendered or when the specified dependencies change.                  
                                                  
//         // const today = new Date().toLocaleDateString('en-CA');
//         // console.log('Token Date:', tokenDate);
//         // console.log('Today\'s Date:', today);
//         //const tokenDate = today; 

        
//         if (tokenDate) {
//             const isValid = tokenDate === today;     //tokenDate === today, setIsTokenValid(true):::    
//             setIsTokenValid(isValid);                
//             console.log('Is Token Valid:', isValid);
//         } else {
//             console.error('Error: tokenDate is undefined or null');
//             setIsTokenValid(false);
//         }
//     }, [tokenDate, today]);       //here we pass the tokenDate and today.

//     const handleRatingChange = (newRating) => {
//         console.log('New rating:', newRating);
//         setRating(newRating);
//     };

//     const handleFeedbackChange = (event) => {
//         console.log('New feedback:', event.target.value);
//         setRemarks(event.target.value);
//     };

//     const handleSubmit = async () => {
//         console.log('Submit button clicked');
//         console.log('isTokenValid:', isTokenValid);
//         console.log('Rating:', rating);
//         console.log('Remarks:', remarks);

//         if (!isTokenValid) {
//             toast.error('Only today’s tokens are allowed for feedback.');
//             return;
//         }

//         if (rating === 0) {
//             toast.error('Please provide a rating before submitting.');
//             return;
//         }

//         try {
//             const response = await canteenFeedback(userID, data?.empid, data?.token, token_no, rating, remarks);
//             //The try block and the canteenFeedback function call are used to handle the process of submitting feedback to the backend API.
//             //const response = await canteenFeedback(userID, data?.empid, data?.token, token_no, rating, remarks,tokenDate); //here pass the tokenDate.
//             console.log('API Response:', response);

//             if (response.status === 'S') {
//                 toast.success('Feedback submitted successfully!');
//                 onClose();
//             } else {
//                 toast.error('Failed to submit feedback.');
//             }
//         } catch (error) {
//             toast.error('Failed to submit feedback.');
//             console.error('Error submitting feedback:', error);
//         }
//     };

//     return (
//         <div className={classes.RateFood}>
//             <h2>Rate Your Food</h2>
//             <div className={classes.Rating}>
//                 <label>Rating: </label>
//                 <ReactStars
//                     count={5}
//                     onChange={handleRatingChange}
//                     size={50}
//                     activeColor="#ffd700"
//                     value={rating}
//                     edit={true} // Always allow interaction
//                 />
//             </div>
//             <div className={classes.Feedback}>
//                 <label>Feedback: </label>
//                 <textarea 
//                     value={remarks} 
//                     onChange={handleFeedbackChange} 
//                     placeholder="Share your thoughts here..."
//                 />
//             </div>
//             <div className={classes.Actions}>
//                 <button 
//                     onClick={handleSubmit}       //The "Submit" button is enabled only when the token is valid (isTokenValid === true) and a rating has been provided (rating > 0), while the "Cancel" button always remains enabled.
//                     disabled={!isTokenValid || rating === 0}        //when button enabled then give the error::
//                 >
//                     Submit                
//                 </button>
//                 <button onClick={onClose}>Cancel</button>
//             </div>
//             {!isTokenValid && (
//                 <p style={{ color: 'red', marginTop: '10px' }}>
//                     Feedback for previous tokens is disabled. Only today’s tokens can be rated.
//                 </p>
//             )}
//         </div>
//     );
// };

// export default RateFood;


///////////---------------------------------------------------------------------------
///////// Replace tokenDate <----->trans_date
/////////-----------------------------------------------------------------------------
// import React, { useState, useEffect } from 'react';
// import classes from './RateFood.module.scss';
// import toast from 'react-hot-toast';
// import ReactStars from 'react-rating-stars-component';
// import { canteenFeedback } from '../../../API/API';

// const RateFood = ({ token_no, onClose, trans_date }) => {
//     const [rating, setRating] = useState(0);         ///////onClose uses to handle handle closing or hiding the component (like closing a modal or feedback form).
//     const [remarks, setRemarks] = useState('');
//     const [isTokenValid, setIsTokenValid] = useState(false);
//     const userID = localStorage.getItem('userID');
//     const data = JSON.parse(localStorage.getItem('data'));
//     const today = new Date().toISOString().split('T')[0]; // Get today's date in 'YYYY-MM-DD' format
//     //const transDate = trans_date.split(' ')[0];    //when we put here gives the error becasue missing or invalid_data.
//     console.log( "transDate", trans_date);
//     console.log(today);
//     console.log(token_no);
//     console.log(data);
//     useEffect(() => {                     ////useEffect called automatically when the component is rendered or when the specified dependencies change.
//         if (trans_date) {            
//             // Extract date part of the trans_date string and format it
//             const transDate = trans_date.split(' ')[0]; // Extracts 'YYYY-MM-DD' :::its takes the only date format not timezone. becase of array[0].
//             console.log(transDate);
//             const isValid = transDate === today; // Compare only the date part  ::::const trans_date = "2025-01-16 12:53:44.923122";
//             console.log(transDate);
//             setIsTokenValid(isValid);        //Set the validation state  :////const transDate = trans_date.split(' ')[0]; :::::const transtime = trans_date.split(' ')[1]; 
//             console.log('Is Token Valid:', isValid);        ////console.log(transDate); //:: Output: "2025-01-16" ///////////////Output:: 12:53:44.923122
//         } else {
//             console.error('Error: trans_date is undefined or null');
//             setIsTokenValid(false);
//         }
//     }, [trans_date, today]);

//     const handleRatingChange = (newRating) => {
//         console.log('New rating:', newRating);
//         setRating(newRating);
//     };

//     console.log('transdate', trans_date);

//     const handleFeedbackChange = (event) => {
//         console.log('New feedback:', event.target.value);
//         setRemarks(event.target.value);
//     };

//     const handleSubmit = async () => {
//         console.log('Submit button clicked');
//         console.log('isTokenValid:', isTokenValid);
//         console.log('Rating:', rating);
//         console.log('Remarks:', remarks);

//         if (!isTokenValid) {
//             toast.error('Only today’s tokens are allowed for feedback.');
//             return;
//         }

//         if (rating === 0) {
//             toast.error('Please provide a rating before submitting.');
//             return;
//         }

//         try {
//             const response = await canteenFeedback(userID, data?.empid, data?.token, token_no, rating, remarks, trans_date);
//             console.log('API Response:', response);

//             if (response.status === 'S') {
//                 toast.success('Feedback submitted successfully!');
//                 onClose();
//             } else {
//                 toast.error('Failed to submit feedback.');
//             }
//         } catch (error) {
//             toast.error('Failed to submit feedback.');
//             console.error('Error submitting feedback:', error);
//         }
//     };
    
//     return (
//         <div className={classes.RateFood}>
//             <h2>Rate Your Food</h2>
//             <div className={classes.Rating}>
//                 <label>Rating: </label>
//                 <ReactStars
//                     count={5}
//                     onChange={handleRatingChange}
//                     size={50}
//                     activeColor="#ffd700"
//                     value={rating}
//                     edit={true}
//                 />
//             </div>
//             <div className={classes.Feedback}>
//                 <label>Feedback: </label>
//                 <textarea 
//                     value={remarks} 
//                     onChange={handleFeedbackChange} 
//                     placeholder="Share your thoughts here..."
//                 />
//             </div>
//             <div className={classes.Actions}>
//                 <button 
//                     onClick={handleSubmit} 
//                     disabled={!isTokenValid || rating === 0}
//                 >
//                     Submit
//                 </button>
//                 <button onClick={onClose}>Cancel</button>
//             </div>
//             {!isTokenValid && (
//                 <p style={{ color: 'red', marginTop: '10px' }}>
//                     Feedback for previous tokens is disabled. Only today’s tokens can be rated.
//                 </p>
//             )}
//         </div>
//     );
// };

// export default RateFood;









































/////////////////////////////////////////////////////////////////////////////
/////////////////When Remove the Token Date//////////////////////////
/////////////////////////////////////////////////////////////////////////////

// import React, { useState, useEffect } from 'react';
// import classes from './RateFood.module.scss';
// import toast from 'react-hot-toast';
// import ReactStars from 'react-rating-stars-component';
// import { canteenFeedback } from '../../../API/API';

// const RateFood = ({ token_no, onClose }) => {
//     const [rating, setRating] = useState(0);
//     const [remarks, setRemarks] = useState('');
//     const [isTokenValid, setIsTokenValid] = useState(false);
//     const userID = localStorage.getItem('userID');
//     const data = JSON.parse(localStorage.getItem('data'));

//     useEffect(() => {
//         const today = new Date().toLocaleDateString('en-CA');  // Get today's date
//         console.log('Today\'s Date:', today);

//         // In this case, just validate feedback can be submitted for today's date
//         const isToday = today === new Date().toLocaleDateString('en-CA');
        
//         // Set isTokenValid to true if today's date matches the condition
//         setIsTokenValid(isToday);

//         console.log('Is Token Valid:', isTokenValid);
//     }, []);

//     const handleRatingChange = (newRating) => {
//         console.log('New rating:', newRating);
//         setRating(newRating);
//     };

//     const handleFeedbackChange = (event) => {
//         console.log('New feedback:', event.target.value);
//         setRemarks(event.target.value);
//     };

//     const handleSubmit = async () => {
//         console.log('Submit button clicked');
//         console.log('isTokenValid:', isTokenValid);
//         console.log('Rating:', rating);
//         console.log('Remarks:', remarks);

//         // Ensure today's date is valid for feedback submission
//         if (!isTokenValid) {
//             toast.error('You can only submit feedback for today\'s date.');
//             return;
//         }

//         // Ensure a rating is provided
//         if (rating === 0) {
//             toast.error('Please provide a rating before submitting.');
//             return;
//         }

//         try {
//             // Adjust API request parameters as needed
//             const response = await canteenFeedback(userID, data?.empid, data?.token, token_no, rating, remarks);
//             console.log('API Response:', response);

//             if (response.status === 'S') {
//                 toast.success('Feedback submitted successfully!');
//                 onClose();  // Close the feedback form after successful submission
//             } else {
//                 toast.error('Failed to submit feedback. Please try again.');
//             }
//         } catch (error) {
//             toast.error('Error submitting feedback. Please try again.');
//             console.error('Error submitting feedback:', error);
//         }
//     };

//     return (
//         <div className={classes.RateFood}>
//             <h2>Rate Your Food</h2>
//             <div className={classes.Rating}>
//                 <label>Rating: </label>
//                 <ReactStars
//                     count={5}
//                     onChange={handleRatingChange}
//                     size={50}
//                     activeColor="#ffd700"
//                     value={rating}
//                     edit={true} // Always allow interaction
//                 />
//             </div>
//             <div className={classes.Feedback}>
//                 <label>Feedback: </label>
//                 <textarea 
//                     value={remarks} 
//                     onChange={handleFeedbackChange} 
//                     placeholder="Share your thoughts here..."
//                 />
//             </div>
//             <div className={classes.Actions}>
//                 <button 
//                     onClick={handleSubmit}
//                     disabled={!isTokenValid || rating === 0} // Disable if not today's date or rating is 0
//                 >
//                     Submit
//                 </button>
//                 <button onClick={onClose}>Cancel</button>
//             </div>
//             {!isTokenValid && (
//                 <p style={{ color: 'red', marginTop: '10px' }} >
//                     Feedback can only be submitted for today. Please come back tomorrow to provide feedback for the next day.
//                 </p>
//             )}
//         </div>
//     );
// };

// export default RateFood;



///////////////////////////////////////////////////////////////////////////////////////
////////////////////This testing code is updated from the BackupCode///////
///////////////////////////////////////////////////////////////////////////////////////
// import React, { useState, useEffect } from 'react';
// import classes from './RateFood.module.scss';
// import toast from 'react-hot-toast';
// import ReactStars from 'react-rating-stars-component';
// import { canteenFeedback } from '../../../API/API';

// const RateFood = ({ token_no, onClose }) => {
//     const [rating, setRating] = useState(0);
//     const [remarks, setRemarks] = useState('');
//     const [isToday, setIsToday] = useState(false); // To track if feedback is for today
//     const userID = localStorage.getItem('userID');
//     const empID = localStorage.getItem('empID');
//     const data = JSON.parse(localStorage.getItem('data'));

//     useEffect(() => {
//         // Check if the token_no corresponds to today's date
//         const today = new Date().toISOString().split('T')[0]; // Format: YYYY-MM-DD
//         const tokenDate = token_no?.split('-')[0]; // Assuming token_no contains the date as 'YYYY-MM-DD-{some_id}'
//                                                    //the date which is seperated by hyphones like 10-12-2024 
//         if (tokenDate === today) {                //.split('-') splits the string into an array using '-' as the delimiter.
//             setIsToday(true);
//         } else {
//             setIsToday(false);
//         }
//     }, [token_no]);        //This ensures that the component reacts to updates in token_no and recalculates whether the date matches today's date.

//     /* Logic Behind above part of  code::: When token_no = "2025-01-01-12345" and Today's Date is "2025-01-01":

//     tokenDate = "2025-01-01", today = "2025-01-01".
//     tokenDate === today → true.
//     isToday is set to true.
//     When token_no = "2025-01-02-54321" and Today's Date is "2025-01-01":
    
//     tokenDate = "2025-01-02", today = "2025-01-01".
//     tokenDate === today → false.
//     isToday is set to false. */



//     const handleRatingChange = (newRating) => {
//         setRating(newRating);
//     };

//     const handleFeedbackChange = (event) => {
//         setRemarks(event.target.value);
//     };

//     const handleSubmit = async () => {
//         if (!isToday) {
//             toast.error('You can only rate food for today!');
//             return;
//         }

//         try {
//             const response = await canteenFeedback(userID, data.empid, data.token, token_no, rating, remarks);

//             if (response) {
//                 toast.success('Feedback submitted successfully!');
//             } else {
//                 toast.error('Failed to submit feedback. Please try again.');
//             }
//             onClose();
//         } catch (error) {
//             toast.error('Failed to submit feedback.');
//             console.error('Error submitting feedback:', error);
//         }
//     };

//     return (
//         <div className={classes.RateFood}>
//             <h2>Rate Your Food</h2>
//             {isToday ? (
//                 <>
//                     <div className={classes.Rating}>
//                         <label>Rating: </label>
//                         <ReactStars
//                             count={5}
//                             onChange={handleRatingChange}
//                             size={50}
//                             activeColor="#ffd700"
//                         />
//                     </div>
//                     <div className={classes.Feedback}>
//                         <label>Feedback: </label>
//                         <textarea value={remarks} onChange={handleFeedbackChange} />
//                     </div>
//                     <div className={classes.Actions}>
//                         <button onClick={handleSubmit}>Submit</button>
//                         <button onClick={onClose}>Cancel</button>
//                     </div>
//                 </>
//             ) : (
//                 <p>You can only rate food for today's date!</p>
//             )}
//         </div>
//     );
// };

// export default RateFood;



































































